// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_j-j","cls2":"PaperClaiming-cls2_8_H PaperClaiming-cls1_j-j"};